export default {
  path: '/order-comment',
  meta: {
    title: '评价',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/order-comment`),
}



// WEBPACK FOOTER //
// ./src/views/OrderComment/router.js